module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Part01"
    }
  }, [_c('p', {
    staticClass: "part-num"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('b', [_vm._v("PART I")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "part-title"
  }, [_c('b', [_c('i', [_vm._v("Lock, Stock and Barrel")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub-title",
    attrs: {
      "id": "sec_1"
    }
  }, [_c('b', [_vm._v("Development of Siege and Fortress Artillery")])]), _vm._v(" "), _c('div', {
    staticClass: "disp-quote1"
  }, [_c('p', {
    staticClass: "center2"
  }, [_vm._v("We march to a battle, not to a review.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Belisarius")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_vm._v("Nothing in life is so exhilarating as to be shot at without result.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Winston Churchill")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_vm._v("When a man has committed no faults in war, he can only have been engaged in it but a short time.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Marshal Turenne")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The ring of hammers and other blunt objects, heavy digging of field fortifications, many times under fire, the building of gun platforms in almost every type of terrain, including muddy, flooded ground, marked the beginning of a siege of a fortress or a strongly fortified city or town. Engineer officers would direct the beginnings of the siege with their templates and instruments, calculating mathematically where to dig and, with their brothers of the artillery, where to emplace the siege batteries to bring the fortress under punishing fire.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Engineer troops, the "), _c('i', [_vm._v("sapeurs du génie")]), _vm._v(" and miners, would prepare their work, the miners getting ready once again to sink their shafts and begin their tunnels toward the fortress to their front and preparing the mining charges that could bring down the curtain walls confronting them. The "), _c('i', [_vm._v("sapeurs")]), _vm._v(" would don their blackened armour, cuirass and lobster helmet, that might, or might not, protect them in the besiegers’ trenches against gunfire from the defenders, and prepare to dig saps and parallels and perhaps lead the infantry assaults.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With the initial saps and approaches dug, the first batteries established with their wooden firing platforms and magazines, the great guns would be brought into position by horse- and man-power, within range of the opposing fortified positions to begin their relentless pounding of the enemy positions both day and night. Siege guns, 16- and 24-pounders, coupled with 8-inch howitzers, would blast the defenders and the great mortars, lofting their deadly bombs over the fortress walls and into the interior would search for the fortresses’ magazines for a lucky shot that might end the siege.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Last of all, but not nearly least, the infantry battalions, when not engaged in digging the siege entrenchments in support of the engineers, would wait until summoned to assault breaches made in the fortress walls if the fortress did not capitulate before that was necessary. The ‘poor bloody infantry’ would bear the burden, and pay the price in blood, for any failure of the engineers, artillerymen, and the senior officers if the siege had not been properly handled before the infantry were sent in.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("With the advent of gunpowder artillery in Europe in the fourteenth century, a balance was usually attempted, and many times achieved, between firepower and mobility. Field artillery came into its own by the middle of the fourth decade of the eighteenth century, pioneered by the Prussians, with the Austrians making similar changes in the next decade. The French followed in the mid-1760s after humiliating defeats in the Seven Years War that clearly demonstrated the inferiority of the then-current Vallière System of Artillery of 1732. Just about every other nation with an interest in artillery followed suit, including the young United States upon declaring independence from Great Britain in 1776.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Heavy artillery, however, was present from the dawn of the arm, and that was a function both of technology, or lack of it, and the need to have guns strong enough to punch through or partially demolish both permanent and field fortifications. Heavy artillery is the main subject of this volume, with its strength and lack of general mobility and inability to keep up with a fast-moving field army being its main characteristics.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The main opponent of siege artillery was fortress or garrison artillery, usually composed of the same guns as siege artillery, but mounted on different gun carriages, designed to be operated inside fortifications and to defend the position where they were emplaced.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Siege and fortress artillery also included howitzers and mortars. The howitzers used in siege and fortress operations were of the same general design as those assigned to the field artillery, but were larger and heavier, with the same restrictions on movement as siege artillery guns. Mortars were stationary artillery pieces, designed for the attack and defence of fortified places, and ranged from small to large and generally speaking fired explosive shell. Howitzers were something like smaller mortars, but mounted on field carriages, and were somewhat more mobile than the mortars.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All siege artillery would be mounted in batteries supervised and constructed by the engineers and artillery officers, and great wooden platforms would be emplaced from which the artillery could fire from a stable position.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sieges were usually carefully undertaken, meticulously planned, and were methodically carried out with the besiegers’ trenches and batteries edging ever-closer to their targets and objective. While the artillery rate of fire might be much slower than that of field artillery in battle, it was relentless and would continue day and night until a breach was made in the curtain wall or the defenders finally capitulated.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The initial siege works and artillery batteries and firing positions completed, sweating gunners manhandled their large, awkward siege pieces onto the firing platforms, managing to get the long gun tubes into the embrasures cut into the field works without damaging the entrenchments. Ammunition would be moved into the magazines constructed in the rear of each siege battery position, dug in and protected from enemy artillery fire. Artillery implements would be placed in each gun position, for the gun crews to use in pointing, loading, and cleaning each piece. The gun crews were smaller than those for field artillery, even though the heavy siege guns were both physically larger than the field pieces, and the guns themselves were of larger calibre.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Large mortars were emplaced in some of the siege battery positions. Of larger calibre than even the largest of the siege guns, mortars would lob bombs over the walls of a besieged fortress, town, or city. These were huge compared to the ammunition fired by the siege guns – some weighing in at 200 pounds. Their crews were also smaller than those in the field artillery, as the mortars were stationary weapons, the guns tubes emplaced in their ‘beds’ – heavy, awkward mounts. Whereas the siege guns were on the familiar wheeled gun carriages which could be moved as necessary, the huge-mouthed mortars would have to be moved by specially constructed vehicles from place to place, and then assembled in their prepared firing positions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Together, the mortars and heavy siege guns, usually known as ‘battering pieces’ would concentrate their firepower against a pre-selected point of the besieged place to prepare it for an infantry assault or to batter the garrison into submission.")])]), _c('div', {
    staticClass: "fig",
    attrs: {
      "id": "ufig_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "fig-img"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "",
      "src": "images/ufig_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "fig-caption"
  }, [_c('b', [_vm._v("Gun Crew Drill:"), _c('br'), _vm._v("I. Clear Vent – before firing to puncture the powder bag; after firing to clear the vent of any foreign material. "), _c('i', [_vm._v("(All items in this sequence courtesy Anne Brown Collection, Brown University)")])])])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d77502","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/14_Part01.vue
// module id = 93
// module chunks = 0